module.exports = __webpack_public_path__ + "img/P2-B7.fc52a5ad.svg";